"use strict";

var _defineProperty = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/defineProperty.js");

var _slicedToArray = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _regeneratorRuntime = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchClientFactory = exports.getBody = exports.getProcessorType = exports.getContentType = void 0;

require("isomorphic-fetch");

var querystring_1 = __importDefault(require("querystring"));

var errors_1 = require("./errors");

var normalizeUrl_1 = require("@autocorp/web-core-utils/lib/normalizeUrl");
/* helps determine content-type for requests/responses */
// text/javascript; charset=utf8


var getContentType = function getContentType(contentType, defaultContentType) {
  var _a, _b, _c;

  return (_c = (_b = (_a = contentType || defaultContentType) === null || _a === void 0 ? void 0 : _a.split(",").shift()) === null || _b === void 0 ? void 0 : _b.split(";").shift()) === null || _c === void 0 ? void 0 : _c.trim();
};

exports.getContentType = getContentType;
/* get content return type, one of: "json" | "text" | "blob" | "arrayBuffer" */

var getProcessorType = function getProcessorType(contentType, defaultContentType) {
  var checkContentType = (0, exports.getContentType)(contentType, defaultContentType);

  switch (checkContentType) {
    case "text/javascript":
    case "text/html":
    case "text/plain":
      return "text";

    default:
      return "json";
  }
};

exports.getProcessorType = getProcessorType;
/* parse request body to match request content-type */

var getBody = function getBody(contentType, body) {
  switch (contentType) {
    case "application/json":
      return JSON.stringify(body);

    default:
      return querystring_1.default.stringify(body);
  }
};

exports.getBody = getBody;

var getResponseBody = function getResponseBody(body, contentType) {
  try {
    switch (contentType) {
      case "json":
        {
          return JSON.parse(body);
        }
    }
  } catch (e) {// noop
  }

  return body;
};

var resolveHeaders = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(headers) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof headers === "function")) {
              _context.next = 4;
              break;
            }

            _context.next = 3;
            return headers();

          case 3:
            return _context.abrupt("return", _context.sent);

          case 4:
            return _context.abrupt("return", headers);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function resolveHeaders(_x) {
    return _ref.apply(this, arguments);
  };
}();

var fetchClientFactory = function fetchClientFactory(baseUrl) {
  var defaultOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(pathname) {
      var options,
          queryParams,
          targetUrl,
          queryString,
          defaultHeaders,
          clientHeaders,
          headers,
          normalizedHeaders,
          requestHeaders,
          body,
          response,
          responseBody,
          _args2 = arguments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
              queryParams = options.queryParams;
              targetUrl = (0, normalizeUrl_1.normalizeUrl)(baseUrl + pathname);
              queryString = querystring_1.default.stringify(Object.assign({}, defaultOptions.queryParams || {}, queryParams || {}));
              _context2.next = 6;
              return resolveHeaders(defaultOptions === null || defaultOptions === void 0 ? void 0 : defaultOptions.headers);

            case 6:
              _context2.t0 = _context2.sent;

              if (_context2.t0) {
                _context2.next = 9;
                break;
              }

              _context2.t0 = {};

            case 9:
              defaultHeaders = _context2.t0;
              _context2.next = 12;
              return resolveHeaders(options === null || options === void 0 ? void 0 : options.headers);

            case 12:
              _context2.t1 = _context2.sent;

              if (_context2.t1) {
                _context2.next = 15;
                break;
              }

              _context2.t1 = {};

            case 15:
              clientHeaders = _context2.t1;
              headers = Object.assign({}, defaultHeaders, clientHeaders);
              normalizedHeaders = Object.entries(headers).reduce(function (acc, _ref3) {
                var _ref4 = _slicedToArray(_ref3, 2),
                    key = _ref4[0],
                    val = _ref4[1];

                var normalizedKey = key.toLowerCase();
                acc[normalizedKey] = val;
                return acc;
              }, {});
              requestHeaders = new Headers(normalizedHeaders);
              body = (0, exports.getBody)((0, exports.getContentType)(requestHeaders.get("Content-Type")), options.body);
              _context2.prev = 20;
              _context2.next = 23;
              return fetch([targetUrl, queryString].filter(Boolean).join("?"), _objectSpread(_objectSpread(_objectSpread({}, defaultOptions), options), {}, {
                headers: requestHeaders,
                body: body
              }));

            case 23:
              response = _context2.sent;
              _context2.next = 29;
              break;

            case 26:
              _context2.prev = 26;
              _context2.t2 = _context2["catch"](20);
              throw new errors_1.RequestError("Failed request to ".concat(targetUrl), _context2.t2, body);

            case 29:
              _context2.t3 = getResponseBody;
              _context2.next = 32;
              return response.text();

            case 32:
              _context2.t4 = _context2.sent;
              _context2.t5 = (0, exports.getProcessorType)(response.headers.get("Content-Type"), requestHeaders.get("Accept"));
              responseBody = (0, _context2.t3)(_context2.t4, _context2.t5);

              if (response.ok) {
                _context2.next = 37;
                break;
              }

              throw new errors_1.ResponseError("Received error response", new Error("Returned unsuccessful response"), responseBody);

            case 37:
              return _context2.abrupt("return", responseBody);

            case 38:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[20, 26]]);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.fetchClientFactory = fetchClientFactory;